import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { engagementApi } from "@/lib/engagement";
import { NewsCard } from "@/components/NewsCard";

// Raccolta Readoo per un trend del Radar: solo notizie già pubblicate, nessun contenuto inventato.
export default function RadarTopic() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { engagementApi.radarTopic(slug).then(setData).catch(() => setData({ keyword: slug, articles: [] })); }, [slug]);
  useEffect(() => { if (data) document.title = `${data.keyword} – Radar Readoo`; }, [data]);
  return (
    <div data-testid="radar-topic-page" className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-brand"><TrendingUp size={14} /> Radar Readoo</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-onSurface capitalize mt-2">{data?.keyword || "…"}</h1>
      {data?.volume && <p className="font-mono text-xs text-subtle mt-1">{data.volume} ricerche in Italia</p>}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {(data?.articles || []).map((a, i) => <NewsCard key={a.article_id} article={a} index={i} />)}
      </div>
      {data && !data.articles.length && <p data-testid="radar-topic-empty" className="text-subtle mt-6">Su Readoo non ci sono ancora notizie su questo argomento.</p>}
    </div>
  );
}
